import { Subject, Observable } from "rxjs";

const subject = new Subject<string>();

export const tabFocusService = {
  setFocus: (target: string): void => subject.next(target),
  getFocus: (): Observable<string> => subject.asObservable(),
};
